import React from 'react';

function clientRandomizer(props) {
  const millsAds = [
    {
      image: '/slacabaret-2022/sponsors/ortho.jpg',
      link: 'https://orthoservices.com/',
      alt: 'Veterinary Orthopedic Services',
      class: 'webFormat',
    },
    {
      image: '/slacabaret-2022/sponsors/zaanti-wholesome.jpg',
      link: '#',
      alt: 'Tea Zaanti and WholesomeCo Direct',
      class: 'webFormat',
    },
    {
      image: '/slacabaret-2022/sponsors/the-party-ad.jpg',
      link: 'https://saltlakeactingcompany.org/',
      alt: 'The Party Annual Fundraiser',
      class: 'webFormat',
    },
    {
      image: '/slacabaret-2022/sponsors/damn-heels.jpg',
      link: 'https://damntheseheels.org/',
      alt: 'Damn these Heels',
      class: 'webFormat',
    },
    {
      image: '/slacabaret-2022/sponsors/third-sun.png',
      link: 'https://thirdsun.com/',
      alt: 'thirdsun',
      class: 'webFormat',
    },
    {
      image: '/slacabaret-2022/sponsors/1wired-roasting.jpg',
      link: 'https://www.google.com/search?q=1wire+phone+and+salt+lake+roasting+company&client=firefox-b-1-d&ei=aWtLYdXcBfe0qtsP-KOk8A0&oq=1wire+phone+and+salt+lake+roasting+company&gs_lcp=Cgdnd3Mtd2l6EAM6BwgAEEcQsANKBAhBGABQ6D5YtkNg7URoAXACeACAAaMBiAHwBJIBAzUuMZgBAKABAcgBCMABAQ&sclient=gws-wiz&ved=0ahUKEwiVtdH9kJPzAhV3mmoFHfgRCd4Q4dUDCA4&uact=5',
      alt: '1Wired and Salt Lake Roasting Co.',
      class: 'webFormat',
    },
    {
      image: '/slacabaret-2022/sponsors/KCPW.jpg',
      link: 'https://kcpw.org/',
      alt: 'KCPW Salt Lake Public Radio',
      class: 'webFormat',
    },
    {
      image: '/slacabaret-2022/sponsors/krcl.jpg',
      link: 'https://krcl.org/',
      alt: 'KRCL',
      class: 'webFormat',
    },
    {
      image: '/slacabaret-2022/sponsors/pbs.jpg',
      link: 'https://pbsutah.org/artelevated',
      alt: 'PBS Utah Ad',
      class: 'webFormat',
    },
    {
      image: '/slacabaret-2022/sponsors/KUER.jpg',
      link: 'https://www.kuer.org/',
      alt: 'Ad for kuer 90.1 NPR radio',
      class: 'webFormat',
    },
    {
      image: '/slacabaret-2022/sponsors/city-home.png',
      link: 'https://www.cityhomecollective.com/',
      alt: 'Ad for CityHome Collective',
      class: 'webFormat',
    },
  ];

  const randomAd = millsAds[Math.floor(Math.random() * millsAds.length)];

  return (
    <>
      <hr />
      <br />
      <a href={randomAd.link} target="_blank" rel="noopener noreferrer">
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </a>
      <br />
      <br />
      <hr />
    </>
  );
}

export default clientRandomizer;
